import ReactGA from 'react-ga4';

// Initialize GA4 with your measurement ID
export const initGA = (measurementId: string) => {
  try {
    ReactGA.initialize(measurementId, {
      gaOptions: {
        debug_mode: true,  // Enable debug mode to see detailed logging
        send_page_view: false // We'll handle this manually to ensure it works
      }
    });
    
    // Test event to verify initialization
    ReactGA.event({
      category: 'Application',
      action: 'Initialize',
      label: 'GA4 Initialization'
    });
    
  } catch (error) {
    console.error('Failed to initialize GA4:', error);
  }
};

// Track page views
export const trackPageView = (path: string) => {
  try {
    ReactGA.send({ 
      hitType: "pageview", 
      page: path,
      title: document.title
    });
  } catch (error) {
    console.error('Failed to track page view:', error);
  }
};

// Track events
export const trackEvent = (category: string, action: string, label?: string, value?: number) => {
  try {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  } catch (error) {
    console.error('Failed to track event:', error);
  }
}; 